import { IoClose } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";

const Model = ({ isOpen, onClose, children, name }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 30,
              duration: 0.5,
            }}
            className="w-full max-w-2xl max-h-[90vh] bg-white rounded shadow-xl overflow-hidden"
          >
            <div className="sticky top-0 z-10 bg-[#758ecd] p-2 flex justify-between items-center border-b border-gray-200">
              <h2 className="text-xl font-semibold text-white px-4 py-1">
                {name}
              </h2>
              <button
                onClick={onClose}
                className="text-white hover:text-black text-2xl transition"
              >
                <IoClose />
              </button>
            </div>

            <div className="overflow-y-auto max-h-[70vh] px-6 my-4">
              {children}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Model;
